import { render, staticRenderFns } from "./file-image.vue?vue&type=template&id=6f7624ec"
import script from "./file-image.vue?vue&type=script&lang=js"
export * from "./file-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports